import get from "lodash/get";
import {
    getInvoiceClientIdLoading,
    getInvoiceClientIdReject,
    getInvoiceClientIdRequest,
    getInvoiceClientIdSuccess,
} from "../../actions/invoiceClient/getId";

export const getInvoiceClientId = (InvoiceId) => async (dispatch, getState) => {
    dispatch(getInvoiceClientIdLoading());
    try {
        const { data } = await getInvoiceClientIdRequest({ InvoiceId }, getState);
        dispatch(getInvoiceClientIdSuccess(data));
    } catch (error) {
        dispatch(getInvoiceClientIdReject(get(error, "response.data", error)));
    }
    return Promise.resolve();
};
